import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Page from "../Components/Page";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserProvider";
import { useTranslation } from "react-i18next";

export default function Logout() {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user, logout } = useUser();
  const { t } = useTranslation();

  useEffect(() => {
    if (user) {
      setIsSubmitting(true);
      (async () => {
        await logout();
        setIsSubmitting(false);
      })();
    }
  }, [user, logout]);

  const title = state?.title as string | "Logout";
  const text = state?.message as string | "Logged out successfully!";

  return (
    <Page title={t(title)} isLoading={isSubmitting}>
      <Typography variant={"body1"}>{t(text)}</Typography>
      <Box mt={2} mb={2}>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            navigate("/login");
          }}
        >
          {t("Login again")}
        </Button>
      </Box>
    </Page>
  );
}
